export { cospi } from './cospi';
export { sinpi } from './sinpi';
export { tanpi, atanpi } from './tanpi';





// WEBPACK FOOTER //
// ./src/lib/trigonometry/index.ts